var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFusionapi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 486.4263 472.3753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "abd8a188-3875-4826-b2aa-e6d329b49487",
    x1: 49.679,
    y1: 209.2378,
    x2: 538.405,
    y2: 209.2378,
    gradientTransform: "matrix(0.8987, -0.0951, 0.0823, 0.4401, -20.2446, 298.5123)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#deebff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#deebff",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#deebff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#deebff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#deebff",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deebff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f8e119e2-fa85-400f-94ab-4f4d32f9f7ec",
    x1: -335.8465,
    y1: 393.7923,
    x2: -335.8465,
    y2: 486.658,
    gradientTransform: "translate(66.4449 502) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe9f9",
    stopOpacity: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5c2ed",
    stopOpacity: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72a0e3",
    stopOpacity: 0.449
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4984db",
    stopOpacity: 0.288
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#296ed4",
    stopOpacity: 0.162
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#125fd0",
    stopOpacity: 0.072
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#0555cd",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#0052cc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#0052cc",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#0052cc",
    stopOpacity: 0.087
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#0052cc",
    stopOpacity: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#0052cc",
    stopOpacity: 0.345
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#0052cc",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#0052cc",
    stopOpacity: 0.774
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff6ec453-7fac-45dc-b663-87239229516c",
    x1: -328.513,
    y1: 402.2971,
    x2: -328.513,
    y2: 453.2735,
    xlinkHref: "#f8e119e2-fa85-400f-94ab-4f4d32f9f7ec"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc48811a-b3f8-444a-8d50-616d4b51e5f7",
    x1: 334.9556,
    y1: 437.2413,
    x2: 410.8981,
    y2: 361.3021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deebff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a370f70d-8f25-41ee-a432-5e5c29be4e56",
    x1: 334.7927,
    y1: 410.4241,
    x2: 409.622,
    y2: 410.4241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0049b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0049b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a55d5bd5-5bc9-489f-a517-6315a10cf658",
    x1: 334.7927,
    y1: 387.3997,
    x2: 409.622,
    y2: 387.3997,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7afa202-30e6-485c-b2ab-dfaba2f0b9d8",
    x1: 10.9556,
    y1: 212.2413,
    x2: 86.8981,
    y2: 136.3021,
    xlinkHref: "#fc48811a-b3f8-444a-8d50-616d4b51e5f7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba379a7e-68f9-429f-bf41-bc9390673f08",
    x1: 10.7927,
    y1: 185.4241,
    x2: 85.622,
    y2: 185.4241,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec1733fd-b4cf-4df2-b398-9629048dc753",
    x1: 10.7927,
    y1: 162.3997,
    x2: 85.622,
    y2: 162.3997,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a66d2c59-1cf9-4913-a2ab-4ae8f618d191",
    x1: 154.9556,
    y1: 333.2413,
    x2: 230.8981,
    y2: 257.3021,
    xlinkHref: "#fc48811a-b3f8-444a-8d50-616d4b51e5f7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b84bd3de-cafc-4d56-be95-6642d3bff5a3",
    x1: 154.7927,
    y1: 306.4241,
    x2: 229.622,
    y2: 306.4241,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd3607df-5694-474f-9db6-567e36fa484d",
    x1: 154.7927,
    y1: 283.3997,
    x2: 229.622,
    y2: 283.3997,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f5fc6e9d-193d-41ee-ac6d-666d3822d2b2",
    x1: 291.602,
    y1: 128.139,
    x2: 345.789,
    y2: 128.139,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b724daa5-c16b-4cc6-ae9a-497066be3196",
    x1: 47.7149,
    y1: 439.1429,
    x2: 123.6575,
    y2: 363.2037,
    xlinkHref: "#fc48811a-b3f8-444a-8d50-616d4b51e5f7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e6f9a3fb-e91b-4b7f-9320-b47eb2d3981e",
    x1: 47.552,
    y1: 412.3258,
    x2: 122.3813,
    y2: 412.3258,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9e98e3c-ea04-4d36-8e25-b564b7663603",
    x1: 47.552,
    y1: 389.3014,
    x2: 122.3813,
    y2: 389.3014,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a47c4999-5c66-4107-856c-11e09b1d25e3",
    x1: 118.3707,
    y1: 121.0507,
    x2: 214.148,
    y2: 25.2775,
    xlinkHref: "#fc48811a-b3f8-444a-8d50-616d4b51e5f7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e9a4a1c0-18a3-47b0-94e8-85ce29c27634",
    x1: 128.5117,
    y1: 61.3073,
    x2: 203.341,
    y2: 61.3073,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "beebfd4f-08ff-48ed-bf29-06d3c85ccfc5",
    x1: 128.5117,
    y1: 38.2829,
    x2: 203.341,
    y2: 38.2829,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff2dc5b9-b022-434b-96a3-231aba0e96c4",
    x1: 128.8005,
    y1: 108.1966,
    x2: 203.6297,
    y2: 108.1966,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2a419f7-6e65-431d-bead-25006da45873",
    x1: 128.8005,
    y1: 85.1722,
    x2: 203.6297,
    y2: 85.1722,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bfaa90ef-9d82-45e4-81da-f1b7ac2759b9",
    x1: 285.9556,
    y1: 249.2413,
    x2: 361.8981,
    y2: 173.3021,
    xlinkHref: "#fc48811a-b3f8-444a-8d50-616d4b51e5f7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a89b5dd6-ad97-4197-b51e-b5039f5027c7",
    x1: 285.7927,
    y1: 222.4241,
    x2: 360.622,
    y2: 222.4241,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be211219-5009-4e73-89f1-d05a1d81a6f2",
    x1: 285.7927,
    y1: 199.3997,
    x2: 360.622,
    y2: 199.3997,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e8e3196f-9171-4b32-9ea0-ec12d2eafe73",
    x1: 269.674,
    y1: 148.0207,
    x2: 297,
    y2: 148.0207,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f55e122c-b6cc-42f3-bf8c-b98689befd05",
    x1: 308.638,
    y1: 344.1478,
    x2: 362.825,
    y2: 344.1478,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b341babd-0991-43a6-b79b-73b828b739cd",
    x1: 286.7099,
    y1: 364.0294,
    x2: 314.036,
    y2: 364.0294,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec7e5129-cb23-48da-ac77-f5f450b69fa4",
    x1: 281.1044,
    y1: 333.3993,
    x2: 308.4305,
    y2: 333.3993,
    xlinkHref: "#a370f70d-8f25-41ee-a432-5e5c29be4e56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a3992448-cd49-4ec0-82eb-83e527cd41b2",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.354,459.5572c-91.0789,7.2935-203.6394,64.1841-213.0512-53.3493-9.3265-116.4682,103.4537-156.4691,218.54-145.833,89.671,8.2874,223.5333,84.1872,228.6843,148.5109S350.4326,452.2638,259.354,459.5572Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      opacity: 0.84,
      fill: "url(#abd8a188-3875-4826-b2aa-e6d329b49487)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.36,97.8184V96.4972h-.1277c-9.0126.7842-16.3176-6.5231-16.3162-15.5357A16.3187,16.3187,0,0,1,301.3166,65.404c-.0608-.8429-.0935-1.6952-.0935-2.5536a34.4185,34.4185,0,0,1,60.919-21.9838A44.89,44.89,0,0,1,450.4606,52.27q0,2.2233-.2135,4.3874a13.776,13.776,0,0,1,3.66-1.3383c6.7883-1.4178,14.49,2.5364,18.8911,7.8758,5.2879,6.4035,2.6316,10.9062,9.77,20.6268a27.0256,27.0256,0,0,0,4.3266,5.0511c8.7749,7.51,23.961,8.482,27.772,8.9458Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      opacity: 0.100000001490116,
      isolation: "isolate",
      fill: "url(#f8e119e2-fa85-400f-94ab-4f4d32f9f7ec)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6286,94v-.7252h-.091c-6.4194.43-11.6226-3.5807-11.6216-8.528.0007-3.9067,3.2867-7.3625,8.12-8.54-.0433-.4627-.0666-.9306-.0666-1.4018-.0083-10.4344,10.9608-18.8984,24.5-18.9049,7.3042-.0034,14.23,2.5033,18.8908,6.8374,4.4692-13.1659,21.9413-21.0469,39.0251-17.6027,14.0795,2.8386,23.8954,12.6465,23.8817,23.8623a18.9618,18.9618,0,0,1-.152,2.4083,11.8035,11.8035,0,0,1,2.6068-.7346c4.8351-.7783,10.3206,1.3923,13.4556,4.3232,3.7664,3.5151,1.8744,5.9867,6.9592,11.3226a16.7351,16.7351,0,0,0,3.0817,2.7727C461.4689,93.2117,472.2856,93.7454,475,94Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      opacity: 0.100000001490116,
      isolation: "isolate",
      fill: "url(#ff6ec453-7fac-45dc-b663-87239229516c)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "b50fc4bb-c9ab-403b-8749-34e3f18c2d25",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 165.2601,
    y1: 129.1733,
    x2: 166.7601,
    y2: 269.6733,
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3764,219.75l27.2275-.2906L367.8764,218.25",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,220a25.483,25.483,0,0,1-17-4c-10.5627-7.1365-10.98-19.7449-11-21",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1111,181.4028l-25.2142-.276L29,179.9786",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.4875,180.6519a25.4824,25.4824,0,0,0,17-4c10.5627-7.1364,10.98-19.7448,11-21",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5128,337.0119l.1938,13.947q.403,29.0113.806,58.0228",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2636,329.6355a25.4829,25.4829,0,0,1,4-17c7.1365-10.5627,19.7449-10.98,21-11",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.8552,374.9756l-.1938-13.947q-.403-29.0113-.806-58.0228",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.1043,382.3521a25.4825,25.4825,0,0,1-4,17c-7.1364,10.5626-19.7448,10.98-21,11",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.6671,407.9992l32.63-.33,135.7487-1.3734",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2907,407.2483a25.4818,25.4818,0,0,1-17-4c-10.5627-7.1364-10.98-19.7448-11-21",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "none",
      stroke: "#384363",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      strokeDasharray: 7
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ac20cd88-21b8-4a82-9551-a3e78e766646",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 369.7717,
    width: 97.8537,
    height: 59,
    rx: 4.2445,
    style: {
      fill: "url(#fc48811a-b3f8-444a-8d50-616d4b51e5f7)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.2683,
    y: 397.8327,
    width: 62.5976,
    height: 2.1585,
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.0066,399.9912h68.4013a3.214,3.214,0,0,1,3.214,3.214V417.643a3.214,3.214,0,0,1-3.214,3.214H338.0066a3.2139,3.2139,0,0,1-3.2139-3.2139v-14.438A3.2139,3.2139,0,0,1,338.0066,399.9912Z",
    style: {
      opacity: 0.2,
      fill: "url(#a370f70d-8f25-41ee-a432-5e5c29be4e56)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.6919,
    y: 384.2935,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(789.5984 9.6164) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.0067,376.9668h68.4012a3.214,3.214,0,0,1,3.214,3.214v14.4379a3.2139,3.2139,0,0,1-3.2139,3.2139H338.0066a3.2139,3.2139,0,0,1-3.2139-3.2139V380.1808A3.214,3.214,0,0,1,338.0067,376.9668Z",
    style: {
      opacity: 0.2,
      fill: "url(#a55d5bd5-5bc9-489f-a517-6315a10cf658)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.6919,
    y: 361.9886,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(767.2935 -12.6885) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.7894,417.4746a1.866,1.866,0,1,1-1.8658-1.8585A1.8621,1.8621,0,0,1,427.7894,417.4746Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.3608,417.6315a1.7348,1.7348,0,1,1-1.7348-1.7281A1.7313,1.7313,0,0,1,419.3608,417.6315Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#f39000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.9058,417.6315a1.7348,1.7348,0,1,1-1.7347-1.7281A1.7313,1.7313,0,0,1,410.9058,417.6315Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.7894,394.9211a1.866,1.866,0,1,1-1.8658-1.8586A1.8623,1.8623,0,0,1,427.7894,394.9211Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.3608,395.078a1.7348,1.7348,0,1,1-1.7348-1.7281A1.7315,1.7315,0,0,1,419.3608,395.078Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#e8e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.9058,395.078a1.7348,1.7348,0,1,1-1.7347-1.7281A1.7315,1.7315,0,0,1,410.9058,395.078Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 144.7717,
    width: 97.8537,
    height: 59,
    rx: 4.2445,
    style: {
      fill: "url(#b7afa202-30e6-485c-b2ab-dfaba2f0b9d8)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2683,
    y: 172.8327,
    width: 62.5976,
    height: 2.1585,
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0066,174.9912H82.4079a3.214,3.214,0,0,1,3.214,3.214V192.643a3.214,3.214,0,0,1-3.214,3.214H14.0066a3.2139,3.2139,0,0,1-3.2139-3.2139v-14.438A3.2139,3.2139,0,0,1,14.0066,174.9912Z",
    style: {
      opacity: 0.2,
      fill: "url(#ba379a7e-68f9-429f-bf41-bc9390673f08)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6919,
    y: 159.2935,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(240.5984 108.6164) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0067,151.9668H82.4079a3.214,3.214,0,0,1,3.214,3.214v14.4379a3.2139,3.2139,0,0,1-3.2139,3.2139H14.0066a3.2139,3.2139,0,0,1-3.2139-3.2139V155.1808A3.214,3.214,0,0,1,14.0067,151.9668Z",
    style: {
      opacity: 0.2,
      fill: "url(#ec1733fd-b4cf-4df2-b398-9629048dc753)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.6919,
    y: 136.9886,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(218.2935 86.3115) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7894,192.4746a1.866,1.866,0,1,1-1.8658-1.8585A1.8621,1.8621,0,0,1,103.7894,192.4746Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3608,192.6315a1.7348,1.7348,0,1,1-1.7348-1.7281A1.7313,1.7313,0,0,1,95.3608,192.6315Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#f39000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9058,192.6315a1.7348,1.7348,0,1,1-1.7347-1.7281A1.7313,1.7313,0,0,1,86.9058,192.6315Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7894,169.9211a1.866,1.866,0,1,1-1.8658-1.8586A1.8623,1.8623,0,0,1,103.7894,169.9211Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3608,170.078A1.7348,1.7348,0,1,1,93.626,168.35,1.7315,1.7315,0,0,1,95.3608,170.078Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#e8e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9058,170.078a1.7348,1.7348,0,1,1-1.7347-1.7281A1.7315,1.7315,0,0,1,86.9058,170.078Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 265.7717,
    width: 97.8537,
    height: 59,
    rx: 4.2445,
    style: {
      fill: "url(#a66d2c59-1cf9-4913-a2ab-4ae8f618d191)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.2683,
    y: 293.8327,
    width: 62.5976,
    height: 2.1585,
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.0066,295.9912h68.4013a3.214,3.214,0,0,1,3.214,3.214V313.643a3.214,3.214,0,0,1-3.214,3.214H158.0066a3.2139,3.2139,0,0,1-3.2139-3.2139v-14.438A3.2139,3.2139,0,0,1,158.0066,295.9912Z",
    style: {
      opacity: 0.2,
      fill: "url(#b84bd3de-cafc-4d56-be95-6642d3bff5a3)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.6919,
    y: 280.2935,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(505.5984 85.6164) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.0067,272.9668h68.4012a3.214,3.214,0,0,1,3.214,3.214v14.4379a3.2139,3.2139,0,0,1-3.2139,3.2139H158.0066a3.2139,3.2139,0,0,1-3.2139-3.2139V276.1808A3.214,3.214,0,0,1,158.0067,272.9668Z",
    style: {
      opacity: 0.2,
      fill: "url(#fd3607df-5694-474f-9db6-567e36fa484d)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.6919,
    y: 257.9886,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(483.2935 63.3115) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.7894,313.4746a1.866,1.866,0,1,1-1.8658-1.8585A1.8621,1.8621,0,0,1,247.7894,313.4746Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3608,313.6315a1.7348,1.7348,0,1,1-1.7348-1.7281A1.7313,1.7313,0,0,1,239.3608,313.6315Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#f39000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.9058,313.6315a1.7348,1.7348,0,1,1-1.7347-1.7281A1.7313,1.7313,0,0,1,230.9058,313.6315Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.7894,290.9211a1.866,1.866,0,1,1-1.8658-1.8586A1.8623,1.8623,0,0,1,247.7894,290.9211Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3608,291.078a1.7348,1.7348,0,1,1-1.7348-1.7281A1.7315,1.7315,0,0,1,239.3608,291.078Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#e8e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.9058,291.078a1.7348,1.7348,0,1,1-1.7347-1.7281A1.7315,1.7315,0,0,1,230.9058,291.078Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "be562cda-9749-4475-80fd-03d8d3977f57",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.2186,133.6714a27.0481,27.0481,0,0,0-.005-11.0749l-4.3492-.613a22.5064,22.5064,0,0,0-2.1185-5.0953l2.6338-3.5075a27.0319,27.0319,0,0,0-7.8708-7.8388l-3.5156,2.6281a22.3592,22.3592,0,0,0-5.1158-2.1206l-.6148-4.3265a27.3452,27.3452,0,0,0-11.1343,0l-.6158,4.3265a22.6178,22.6178,0,0,0-5.1257,2.1206l-3.5166-2.6231a27.14,27.14,0,0,0-7.8589,7.8288l2.6327,3.5125a22.5563,22.5563,0,0,0-2.1184,5.0953l-4.3493.613a27.092,27.092,0,0,0-.0049,11.0749l4.3542.6232A22.0969,22.0969,0,0,0,298.66,139.38l-2.6486,3.5224a27.14,27.14,0,0,0,7.8589,7.8289l3.5265-2.6331a22.3254,22.3254,0,0,0,5.1158,2.11l.6208,4.3465a27.2824,27.2824,0,0,0,11.1233,0l.6208-4.3465a22.3273,22.3273,0,0,0,5.1158-2.11l3.5215,2.6381a27.1886,27.1886,0,0,0,7.8649-7.8339l-2.6486-3.5124a22.3554,22.3554,0,0,0,2.1333-5.0952ZM318.69,141.1476a13.0137,13.0137,0,1,1,13.0649-13.0136A13.0273,13.0273,0,0,1,318.69,141.1476Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      opacity: 0.1,
      fill: "url(#f5fc6e9d-193d-41ee-ac6d-666d3822d2b2)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.7594,
    y: 371.6733,
    width: 97.8537,
    height: 59,
    rx: 4.2445,
    style: {
      fill: "url(#b724daa5-c16b-4cc6-ae9a-497066be3196)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.0276,
    y: 399.7343,
    width: 62.5976,
    height: 2.1585,
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.766,401.8928h68.4013a3.214,3.214,0,0,1,3.214,3.214v14.4378a3.214,3.214,0,0,1-3.214,3.214H50.766a3.2139,3.2139,0,0,1-3.2139-3.2139v-14.438A3.2139,3.2139,0,0,1,50.766,401.8928Z",
    style: {
      opacity: 0.2,
      fill: "url(#e6f9a3fb-e91b-4b7f-9320-b47eb2d3981e)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.4512,
    y: 386.1951,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(504.2594 298.7587) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7661,378.8684h68.4012a3.214,3.214,0,0,1,3.214,3.214V396.52a3.2139,3.2139,0,0,1-3.2139,3.2139H50.766A3.2139,3.2139,0,0,1,47.552,396.52V382.0825A3.214,3.214,0,0,1,50.7661,378.8684Z",
    style: {
      opacity: 0.2,
      fill: "url(#a9e98e3c-ea04-4d36-8e25-b564b7663603)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.4512,
    y: 363.8902,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(481.9545 276.4538) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5488,419.3762a1.866,1.866,0,1,1-1.8659-1.8585A1.8622,1.8622,0,0,1,140.5488,419.3762Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.12,419.5331a1.7348,1.7348,0,1,1-1.7348-1.728A1.7313,1.7313,0,0,1,132.12,419.5331Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#f39000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6652,419.5331a1.7348,1.7348,0,1,1-1.7347-1.728A1.7313,1.7313,0,0,1,123.6652,419.5331Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5488,396.8227a1.866,1.866,0,1,1-1.8659-1.8586A1.8623,1.8623,0,0,1,140.5488,396.8227Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.12,396.98a1.7348,1.7348,0,1,1-1.7348-1.728A1.7315,1.7315,0,0,1,132.12,396.98Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#e8e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6652,396.98a1.7348,1.7348,0,1,1-1.7347-1.728A1.7315,1.7315,0,0,1,123.6652,396.98Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.7594,
    y: 20.6548,
    width: 93,
    height: 105.0185,
    rx: 5.5206,
    style: {
      fill: "url(#a47c4999-5c66-4107-856c-11e09b1d25e3)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.9873,
    y: 48.7158,
    width: 62.5976,
    height: 2.1585,
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7256,50.8743h68.4013a3.214,3.214,0,0,1,3.214,3.214V68.5262a3.214,3.214,0,0,1-3.214,3.214H131.7256a3.2139,3.2139,0,0,1-3.2139-3.2139V54.0883a3.2139,3.2139,0,0,1,3.2139-3.2139Z",
    style: {
      opacity: 0.2,
      fill: "url(#e9a4a1c0-18a3-47b0-94e8-85ce29c27634)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.4109,
    y: 35.1766,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(234.2005 -133.2195) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7257,27.85h68.4012a3.214,3.214,0,0,1,3.214,3.214V45.5019a3.2139,3.2139,0,0,1-3.2139,3.2139H131.7256a3.2139,3.2139,0,0,1-3.2139-3.2139V31.064A3.214,3.214,0,0,1,131.7257,27.85Z",
    style: {
      opacity: 0.2,
      fill: "url(#beebfd4f-08ff-48ed-bf29-06d3c85ccfc5)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.4109,
    y: 12.8718,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(211.8956 -155.5243) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5084,68.3577a1.866,1.866,0,1,1-1.8658-1.8585A1.8621,1.8621,0,0,1,221.5084,68.3577Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.08,68.5146a1.7348,1.7348,0,1,1-1.7348-1.728A1.7314,1.7314,0,0,1,213.08,68.5146Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#f39000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6248,68.5146a1.7348,1.7348,0,1,1-1.7347-1.728A1.7313,1.7313,0,0,1,204.6248,68.5146Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5084,45.8042a1.866,1.866,0,1,1-1.8658-1.8586A1.8622,1.8622,0,0,1,221.5084,45.8042Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.08,45.9611a1.7348,1.7348,0,1,1-1.7348-1.728A1.7316,1.7316,0,0,1,213.08,45.9611Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#e8e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6248,45.9611a1.7348,1.7348,0,1,1-1.7347-1.728A1.7315,1.7315,0,0,1,204.6248,45.9611Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.2761,
    y: 95.6051,
    width: 62.5976,
    height: 2.1585,
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.0144,97.7637h68.4013a3.214,3.214,0,0,1,3.214,3.214v14.4378a3.214,3.214,0,0,1-3.214,3.214H132.0144a3.2139,3.2139,0,0,1-3.2139-3.2139v-14.438A3.2139,3.2139,0,0,1,132.0144,97.7637Z",
    style: {
      opacity: 0.2,
      fill: "url(#ff2dc5b9-b022-434b-96a3-231aba0e96c4)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.6996,
    y: 82.0659,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(281.3786 -86.6189) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.0145,74.7393h68.4012a3.214,3.214,0,0,1,3.214,3.214V92.3912a3.2139,3.2139,0,0,1-3.2139,3.2139H132.0144A3.2139,3.2139,0,0,1,128.8,92.3912V77.9533A3.214,3.214,0,0,1,132.0145,74.7393Z",
    style: {
      opacity: 0.2,
      fill: "url(#a2a419f7-6e65-431d-bead-25006da45873)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.6996,
    y: 59.7611,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(259.0737 -108.9238) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7972,115.247a1.866,1.866,0,1,1-1.8659-1.8585A1.8622,1.8622,0,0,1,221.7972,115.247Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3686,115.4039a1.7348,1.7348,0,1,1-1.7348-1.728A1.7314,1.7314,0,0,1,213.3686,115.4039Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#f39000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.9136,115.4039a1.7348,1.7348,0,1,1-1.7347-1.728A1.7313,1.7313,0,0,1,204.9136,115.4039Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7972,92.6935a1.866,1.866,0,1,1-1.8659-1.8586A1.8622,1.8622,0,0,1,221.7972,92.6935Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3686,92.85a1.7348,1.7348,0,1,1-1.7348-1.728A1.7315,1.7315,0,0,1,213.3686,92.85Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#e8e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.9136,92.85a1.7348,1.7348,0,1,1-1.7347-1.728A1.7315,1.7315,0,0,1,204.9136,92.85Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 181.7717,
    width: 97.8537,
    height: 59,
    rx: 4.2445,
    style: {
      fill: "url(#bfaa90ef-9d82-45e4-81da-f1b7ac2759b9)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.2683,
    y: 209.8327,
    width: 62.5976,
    height: 2.1585,
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.0066,211.9912h68.4013a3.214,3.214,0,0,1,3.214,3.214V229.643a3.214,3.214,0,0,1-3.214,3.214H289.0066a3.2139,3.2139,0,0,1-3.2139-3.2139v-14.438A3.2139,3.2139,0,0,1,289.0066,211.9912Z",
    style: {
      opacity: 0.2,
      fill: "url(#a89b5dd6-ad97-4197-b51e-b5039f5027c7)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.6919,
    y: 196.2935,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(552.5984 -129.3836) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.0067,188.9668h68.4012a3.214,3.214,0,0,1,3.214,3.214v14.4379a3.2139,3.2139,0,0,1-3.2139,3.2139H289.0066a3.2139,3.2139,0,0,1-3.2139-3.2139V192.1808A3.214,3.214,0,0,1,289.0067,188.9668Z",
    style: {
      opacity: 0.2,
      fill: "url(#be211219-5009-4e73-89f1-d05a1d81a6f2)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.6919,
    y: 173.9886,
    width: 11.5122,
    height: 66.1951,
    transform: "translate(530.2935 -151.6885) rotate(90)",
    style: {
      fill: "#3d4959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.7894,229.4746a1.866,1.866,0,1,1-1.8658-1.8585A1.8621,1.8621,0,0,1,378.7894,229.4746Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.3608,229.6315a1.7348,1.7348,0,1,1-1.7348-1.7281A1.7313,1.7313,0,0,1,370.3608,229.6315Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#f39000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9058,229.6315a1.7348,1.7348,0,1,1-1.7347-1.7281A1.7313,1.7313,0,0,1,361.9058,229.6315Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.7894,206.9211a1.866,1.866,0,1,1-1.8658-1.8586A1.8623,1.8623,0,0,1,378.7894,206.9211Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#0069b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.3608,207.078a1.7348,1.7348,0,1,1-1.7348-1.7281A1.7315,1.7315,0,0,1,370.3608,207.078Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#e8e9ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9058,207.078a1.7348,1.7348,0,1,1-1.7347-1.7281A1.7315,1.7315,0,0,1,361.9058,207.078Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      fill: "#cfd0da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.7123,150.8106a13.64,13.64,0,0,0-.0024-5.5849l-2.1934-.3092a11.3467,11.3467,0,0,0-1.0683-2.57l1.3282-1.7688a13.6317,13.6317,0,0,0-3.9692-3.953l-1.7728,1.3253a11.2731,11.2731,0,0,0-2.58-1.0694l-.31-2.1818a13.785,13.785,0,0,0-5.6148,0l-.3106,2.1818a11.402,11.402,0,0,0-2.5848,1.0694l-1.7734-1.3228a13.6859,13.6859,0,0,0-3.9632,3.948l1.3277,1.7713a11.37,11.37,0,0,0-1.0683,2.57l-2.1934.3092a13.6633,13.6633,0,0,0-.0024,5.5849l2.1958.3143a11.1426,11.1426,0,0,0,1.0762,2.5644l-1.3356,1.7764a13.6872,13.6872,0,0,0,3.9632,3.948l1.7783-1.3278a11.2682,11.2682,0,0,0,2.58,1.0643l.313,2.1919a13.7639,13.7639,0,0,0,5.61,0l.313-2.1919a11.2682,11.2682,0,0,0,2.58-1.0643l1.7758,1.33a13.7109,13.7109,0,0,0,3.9662-3.9505l-1.3356-1.7713a11.2745,11.2745,0,0,0,1.0757-2.57Zm-13.3783,3.77a6.5627,6.5627,0,1,1,6.5886-6.5626A6.57,6.57,0,0,1,283.334,154.5808Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      opacity: 0.1,
      fill: "url(#e8e3196f-9171-4b32-9ea0-ec12d2eafe73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.2546,349.68a27.0481,27.0481,0,0,0-.005-11.0749l-4.3493-.6131a22.5034,22.5034,0,0,0-2.1184-5.0953l2.6338-3.5074a27.0359,27.0359,0,0,0-7.8708-7.8389l-3.5156,2.6281a22.3589,22.3589,0,0,0-5.1158-2.12l-.6149-4.3266a27.3447,27.3447,0,0,0-11.1342,0l-.6158,4.3266a22.6175,22.6175,0,0,0-5.1257,2.12l-3.5166-2.623a27.14,27.14,0,0,0-7.8589,7.8287l2.6327,3.5125a22.5536,22.5536,0,0,0-2.1184,5.0953l-4.3493.6131a27.092,27.092,0,0,0-.0049,11.0749l4.3542.6231a22.0929,22.0929,0,0,0,2.1342,5.0852l-2.6485,3.5225a27.1407,27.1407,0,0,0,7.8589,7.8288l3.5265-2.633a22.3343,22.3343,0,0,0,5.1158,2.1105l.6208,4.3465a27.2871,27.2871,0,0,0,11.1233,0l.6208-4.3465a22.3362,22.3362,0,0,0,5.1158-2.1105l3.5215,2.6381a27.1923,27.1923,0,0,0,7.8649-7.8339l-2.6486-3.5124a22.35,22.35,0,0,0,2.1332-5.0953Zm-26.529,7.4761a13.0137,13.0137,0,1,1,13.065-13.0136A13.0272,13.0272,0,0,1,335.7256,357.1563Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      opacity: 0.1,
      fill: "url(#f55e122c-b6cc-42f3-bf8c-b98689befd05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7483,366.8194a13.6383,13.6383,0,0,0-.0025-5.585l-2.1933-.3091a11.3448,11.3448,0,0,0-1.0683-2.57l1.3282-1.7688a13.6321,13.6321,0,0,0-3.9692-3.9531l-1.7728,1.3253a11.2794,11.2794,0,0,0-2.58-1.0694l-.31-2.1818a13.79,13.79,0,0,0-5.6149,0l-.31,2.1818a11.4092,11.4092,0,0,0-2.5849,1.0694l-1.7734-1.3228a13.6881,13.6881,0,0,0-3.9631,3.948l1.3276,1.7714a11.3722,11.3722,0,0,0-1.0683,2.57L287,361.2344a13.6614,13.6614,0,0,0-.0025,5.585l2.1958.3142a11.1436,11.1436,0,0,0,1.0763,2.5645l-1.3356,1.7763a13.6856,13.6856,0,0,0,3.9631,3.948l1.7784-1.3278a11.2593,11.2593,0,0,0,2.58,1.0643l.313,2.1919a13.7587,13.7587,0,0,0,5.6094,0l.3131-2.1919a11.2611,11.2611,0,0,0,2.58-1.0643l1.7758,1.33a13.7137,13.7137,0,0,0,3.9662-3.9506l-1.3356-1.7713a11.2726,11.2726,0,0,0,1.0757-2.57ZM300.37,370.59a6.5627,6.5627,0,1,1,6.5885-6.5627A6.57,6.57,0,0,1,300.37,370.59Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      opacity: 0.1,
      fill: "url(#b341babd-0991-43a6-b79b-73b828b739cd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.1428,336.1893a13.6383,13.6383,0,0,0-.0025-5.585l-2.1933-.3092a11.3467,11.3467,0,0,0-1.0683-2.57l1.3282-1.7688a13.6329,13.6329,0,0,0-3.9692-3.953l-1.7728,1.3253a11.275,11.275,0,0,0-2.58-1.0694l-.31-2.1818a13.7855,13.7855,0,0,0-5.6149,0l-.31,2.1818a11.4046,11.4046,0,0,0-2.5849,1.0694l-1.7734-1.3228a13.6856,13.6856,0,0,0-3.9631,3.948l1.3276,1.7713a11.3741,11.3741,0,0,0-1.0683,2.57l-2.1933.3092a13.6614,13.6614,0,0,0-.0025,5.585l2.1958.3142a11.1428,11.1428,0,0,0,1.0763,2.5644l-1.3356,1.7764a13.6868,13.6868,0,0,0,3.9631,3.948l1.7784-1.3278a11.2682,11.2682,0,0,0,2.58,1.0643l.313,2.1919a13.7634,13.7634,0,0,0,5.6094,0l.3131-2.1919a11.27,11.27,0,0,0,2.58-1.0643l1.7758,1.33a13.7122,13.7122,0,0,0,3.9662-3.9505l-1.3356-1.7713a11.2745,11.2745,0,0,0,1.0757-2.57Zm-13.3783,3.77a6.5627,6.5627,0,1,1,6.5885-6.5626A6.57,6.57,0,0,1,294.7645,339.9594Z",
    transform: "translate(-28.2406 -7.3267)",
    style: {
      opacity: 0.1,
      fill: "url(#ec7e5129-cb23-48da-ac77-f5f450b69fa4)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusionapi);
export default __webpack_public_path__ + "static/media/fusionapi.c1d786e32300e2c754a669522986eecf.svg";
export { ForwardRef as ReactComponent };